export default __webpack_public_path__ + "static/group-7-90da6211174ab738dcbd710e67fddae2.png";